import { render, staticRenderFns } from "./updatePass.vue?vue&type=template&id=1cf7fac7&scoped=true"
import script from "./updatePass.vue?vue&type=script&lang=js"
export * from "./updatePass.vue?vue&type=script&lang=js"
import style0 from "./updatePass.vue?vue&type=style&index=0&id=1cf7fac7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cf7fac7",
  null
  
)

export default component.exports